module.exports = __webpack_public_path__ + "img/icon-1.33a59bf2.svg";